import React, { useState } from 'react';
import { useStyletron } from 'baseui';
import { Notification, KIND } from 'baseui/notification';
import RoomList from './RoomList';
import CreateRoomModal from './CreateRoomModal';
import FloatingActionButton from './FloatingActionButton';

const ChatDashboardHome: React.FC = () => {
	const [css] = useStyletron();
	const [isCreateModalOpen, setIsCreateModalOpen] = useState(false);
	const [refreshTrigger, setRefreshTrigger] = useState(0);
	const [notification, setNotification] = useState<{ message: string; kind: typeof KIND[keyof typeof KIND] } | null>(null);

	const handleCreateSuccess = (roomId: string) => {
		setNotification({
			message: `Room created successfully! Room ID: ${roomId}`,
			kind: KIND.positive
		});
		// Trigger refresh of room list
		setRefreshTrigger((prev) => prev + 1);
	};

	return (
		<div
			className={css({
				padding: '32px',
				backgroundColor: '#f8f9fa',
				minHeight: '100vh'
			})}>
			<div
				className={css({
					maxWidth: '1400px',
					margin: '0 auto'
				})}>
				{notification && (
					<div className={css({ marginBottom: '24px' })}>
						<Notification kind={notification.kind} onClose={() => setNotification(null)}>
							{notification.message}
						</Notification>
					</div>
				)}

				{/* Room List */}
				<RoomList key={refreshTrigger} />

				{/* Create Room Modal */}
				<CreateRoomModal
					isOpen={isCreateModalOpen}
					onClose={() => setIsCreateModalOpen(false)}
					onSuccess={handleCreateSuccess}
				/>

				{/* Floating Action Button */}
				<FloatingActionButton onClick={() => setIsCreateModalOpen(true)} />
			</div>
		</div>
	);
};
export default ChatDashboardHome;
